import React, { useState, useEffect, useRef } from "react";
import "./Accessibility.css";

export default function Accessibility() {
  const [fontSize, setFontSize] = useState(16);
  const [darkMode, setDarkMode] = useState(false);
  const googleTranslateLoaded = useRef(false);
  // Apply font size
  useEffect(() => {
    document.documentElement.style.fontSize = fontSize + "px";
  }, [fontSize]);

  // Apply dark mode
  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
  }, [darkMode]);

 
useEffect(() => {
    if (googleTranslateLoaded.current) return;

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        { pageLanguage: "en", includedLanguages: "ta,en", autoDisplay: true },
        "google_translate_element"
      );
    };
    // Load Google Translate after a delay
    const timer = setTimeout(() => {
      const script = document.createElement("script");
      script.src =
        "//translate.googleapis.com/translate_a/element.js?cb=googleTranslateElementInit";
        // script.setHeader("Access-Control-Allow-Origin", "*")
      document.body.appendChild(script);
    }, 3000); // delay to avoid map rendering conflict

    return () => clearTimeout(timer);
  }, []);

  const openWidget = () => {
    if (typeof window.openA11yWidget === "function") {
      window.openA11yWidget(); // uses the robust bridge
    } else {
      // Fallback: dispatch the custom event (bridge listens for it)
      window.dispatchEvent(new Event("ux4g:open"));
    }
  };




  return (
    <header className="govt-header">
      <div className="logo-section">
        {/* <img src={logo} alt="Government of India" className="govt-logo" /> */}
        <h2>Zone</h2>
      </div>

      <div className="controls-section">
        {/* Accessibility */}

        {/* Font size */}
        <button onClick={() => setFontSize(fontSize - 1)}>A-</button>
        <button onClick={() => setFontSize(16)}>A</button>
        <button onClick={() => setFontSize(fontSize + 1)}>A+</button>

        {/* Dark mode */}
        <button onClick={() => setDarkMode(!darkMode)}>
          {darkMode ? "☀️" : "🌙"}
        </button>

        {/* Google Translate */}
        <div id="google_translate_element" className="translate-box">
        </div>
          {/* <button onClick={openAccessibilityWidget}>♿more</button> */}
           <button id="accessibility-widget-btn" onClick={openWidget} >
            ♿ More</button>
      </div>
    </header>
  );
}
